import { invokeApi } from "src/bl_libs/invokeApi";

/** Logged-in member portal — trackers this member can access. */
export const getMemberTrackersApi = async () => {
  const requestObj = {
    path: `/api/member_tracker`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

/** Logged-in member portal — one tracker + own submissions. */
export const getMemberTrackerDetailApi = async (idOrSlug) => {
  const requestObj = {
    path: `/api/member_tracker/${encodeURIComponent(idOrSlug)}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

/**
 * Logged-in member portal — unlock a password-protected journey.
 * 200 unlocks it for this member; 403 = wrong password; 429 = too many attempts.
 */
export const verifyMemberTrackerPasswordApi = async (idOrSlug, data = {}) => {
  const requestObj = {
    path: `/api/member_tracker/${encodeURIComponent(idOrSlug)}/verify_password`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: {
      password: data.password || "",
    },
  };
  return invokeApi(requestObj);
};

/**
 * Logged-in member portal — submit tracker answers.
 * Always sends x-sh-auth; backend tags source = gymrite_member.
 */
export const submitMemberTrackerApi = async (idOrSlug, data = {}) => {
  const requestObj = {
    path: `/api/member_tracker/${encodeURIComponent(idOrSlug)}/submissions`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: {
      formId: data.formId || "",
      answers: data.answers || {},
    },
  };
  return invokeApi(requestObj);
};

/**
 * Logged-in member portal — leave a journey (status change, not a delete).
 * reason: not_right_fit | injury_health | no_time | other; note optional.
 */
export const leaveMemberTrackerApi = async (idOrSlug, data = {}) => {
  const requestObj = {
    path: `/api/member_tracker/${encodeURIComponent(idOrSlug)}/leave`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: {
      reason: data.reason || "",
      note: data.note || "",
    },
  };
  return invokeApi(requestObj);
};
